export default __webpack_public_path__ + "images/onboarding/fractions-0161853d3e5fb989ccbd46537d0ed68e.svg";